export default __webpack_public_path__ + "178cff7983c29664b3107f96eb251c8d.svg";